<template>
<div :class="['xiaobu-layout-box', !openSidebar ? 'hideSidebar' : 'openSidebar', device==='mobile' ? 'mobile' : '']">
  <!-- 移动端时 打开菜单后的 阴影遮罩 -->
  <div v-if="showMask" class="drawer-bg" @click="handleCloseMask"></div>
  <div :class="{'xiaobu-sidebar-container': true, 'hide-side': !openSidebar, 'show-mask': showMask}">
    <logo></logo>
    <sidebar :key="screenHeight" class="xiaobu-sidebar-box"></sidebar>
  </div>
  <div :class="{'xiaobu-main-container': true, 'hide-side': !openSidebar}">
    <div class="header-box">
      <navbar></navbar>
      <tags-view></tags-view>
    </div>
    <app-main :class="['xiaobu-app-main', showMask ? 'show-mask' : '']">
    </app-main>
    <iframe-box :class="['iframe-box', showFooter ? 'has-footer' : '']"></iframe-box>
    <footer-box v-show="showFooter" class="xiaobu-app-footer"></footer-box>
  </div>
</div>

</template>
<script>
import {Logo, Navbar, FooterBox, TagsView, AppMain, Sidebar, IframeBox} from "./components/index"
import ResizeMixin from "./mixin/ResizeHandler"
export default {
  components: {
    Logo,
    Navbar, 
    TagsView,
    AppMain,
    Sidebar,
    FooterBox,
    IframeBox
  },
  mixins: [ResizeMixin],
  watch: {
    // 展示遮罩层时 禁止滚动
    showMask(val) {
      if (val) {
        document.body.style.overflow = "hidden"
      } else {
        document.body.style.overflow = ""
      }
    }
  },
  computed: {
    // 展示遮罩层
    showMask() {
      return this.device==="mobile"&&this.openSidebar
    },
    //侧边栏配置
    openSidebar() {
      return this.$store.getters.openSidebar
    },
    // 展示页脚
    showFooter() {
      const {meta} = this.$route
      return meta.showFooter
    },
    //设备
    device() {
      return this.$store.state.app.device
    },
    // 屏幕高度
    screenHeight() {
      return this.$store.getters.screenHeight
    }
  },
  methods: {
    // 关闭遮罩层
    handleCloseMask() {
      this.$store.dispatch("app/closeSideBar")
    }
  }
}
</script>
<style scoped lang="scss">
.xiaobu-layout-box {
  position: relative;
  height: 100%;
  width: 100%;
  z-index: $LayoutIndex;
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: fixed;
    z-index: calc(#{$LayoutIndex} + 1);
  }
  .xiaobu-sidebar-container {
    transition: width .28s;
    width: $LayoutSidebarWidth;
    height: 100%;
    position: fixed;
    font-size: 0;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: calc(#{$LayoutIndex} + 3);
    overflow: hidden;
    margin-top: 0;
    &.hide-side {
      width: $LayoutSmallSideWidth !important;
    }
    .sidebar-logo-container{
      display: block;
    }
    &.show-mask{
      margin-top: $LayoutHeaderHeight;
      .sidebar-logo-container{
        display: none;
      }
    }
    .xiaobu-sidebar-box{
      height: calc(100% - #{$LayoutHeaderHeight});
    }
  }

  .xiaobu-main-container{
    min-height: 100%;
    transition: margin-left .36s;
    margin-left: $LayoutSidebarWidth;
    position: relative;
    overflow-y: hidden;
    background: #f2f2f2;
    // z-index: $LayoutIndex;
    &.hide-side {
      margin-left: $LayoutSmallSideWidth !important;
      width: calc(100% - #{$LayoutSmallSideWidth}) !important;
      .header-box{ 
        width: calc(100% - #{$LayoutSmallSideWidth});
      }
    }

    .header-box{
      position: fixed;
      top: 0;
      right: 0;
      z-index: calc(#{$LayoutIndex} + 2);
      width: calc(100% - #{$LayoutSidebarWidth});
      transition: width .36s;
    }

    .xiaobu-app-main{
      background: #f2f2f2;
      padding-top: calc(#{$LayoutHeaderHeight} + #{$LayoutTagsHeight});
      //解决 当屏幕较小 展示侧边菜单后 显示右边遮罩，但是点击菜单 加载列表的 遮罩冲突了，难看
      &.show-mask{
        ::v-deep .el-loading-mask{
          background-color: unset;
        }
      }
    }

    .iframe-box.has-footer {
      height: calc(100vh - #{$LayoutHeaderHeight} - #{$LayoutTagsHeight} - #{$LayoutFooterHeight} ) !important;
    }
  }
}
</style>